import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import { track } from '@amplitude/analytics-browser'
import { AskAiBox, Button, MetricCard, colors } from 'src/components/app-ui'
import {
  courseReportAction,
  getCourseAnalyticsReportAction,
} from 'src/reducers/course/action'

const AI_QUESTIONS = [
  'Which section loses the most learners?',
  'Why is completion low on the last section?',
  'Compare this course with my other courses',
]

const formatScore = score =>
  score == null || score === 'NaN' ? '-' : `${score} %`

const METRICS = [
  {
    label: 'Eligible learners',
    hint:
      'Learners who are allowed to open this course under the current access setting.',
    icon: 'tabler:chart-bar',
    iconColor: '#5DADFF',
    pick: data => (data?.assigned == null ? 'All' : data.assigned),
  },
  {
    label: 'Engaged learners',
    hint: 'Learners who opened at least one page.',
    icon: 'tabler:chart-bar',
    iconColor: colors.primary,
    pick: data => data?.engaged ?? 0,
  },
  {
    label: 'Learners who completed',
    hint: 'Learners who reached the last page.',
    icon: 'tabler:chart-bar',
    iconColor: colors.success,
    pick: data => data?.completed ?? 0,
  },
  {
    label: 'Learners with badges',
    hint: 'Learners who earned at least one badge, including fail badges.',
    icon: 'tabler:badge',
    iconColor: colors.muted,
    pick: data => data?.badgeCount ?? 0,
  },
  {
    label: 'Average success score',
    hint: 'Average score across quiz and interactive blocks.',
    icon: 'tabler:help-square',
    iconColor: colors.muted,
    pick: data => formatScore(data?.averageScore),
  },
]

const useStyles = makeStyles({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: '16px',
  },
  download: {
    alignSelf: 'center',
    boxShadow: '0 2px 4px rgba(145,158,171,.32)',
  },
})

const AnalyticsTab = ({ course }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [data, setData] = useState(null)

  useEffect(() => {
    dispatch(getCourseAnalyticsReportAction(course.id, setData))
  }, [dispatch, course.id])

  const download = () => {
    track('course_analytics_clicked')
    dispatch(courseReportAction(course.id))
  }

  return (
    <>
      <div className={classes.grid}>
        {METRICS.map(metric => (
          <MetricCard
            key={metric.label}
            label={metric.label}
            hint={metric.hint}
            value={metric.pick(data)}
            icon={metric.icon}
            iconColor={metric.iconColor}
          />
        ))}
      </div>
      <Button
        icon="tabler:download"
        className={classes.download}
        onClick={download}
      >
        Download full report
      </Button>
      <AskAiBox questions={AI_QUESTIONS} />
    </>
  )
}

export default AnalyticsTab
